module.exports = __webpack_public_path__ + "img/success.99e3ace7.webp";